import paginateAction from '@utils/paginateAction';
import { helpCenterTypes } from '../constants';
import { paginatorListSchema } from '../schemas';

const freshbotCdnUrl = 'https://support-bot-cdn.uacdn.net/';
const freshbotUrl = 'https://support-bot.unacademy.com/';

export const onChatOpen =
  (role = 'learner') =>
  (dispatch) =>
    dispatch({
      type: helpCenterTypes.ON_CHAT_OPEN,
      endpoint: `${freshbotUrl}history/on_open`,
      method: 'put',
      useJWTToken: true,
      data: {
        role
      }
    });

export const fetchCategories =
  ({ goalUid, portal = 'plus' }) =>
  (dispatch) =>
    dispatch({
      type: helpCenterTypes.FETCH_CATEGORIES,
      endpoint: `${freshbotCdnUrl}freshdesk/v1/categories?goal=${goalUid}&portal=${portal}`,
      method: 'get'
    });

const getArticles = (key, resetWithoutEmpty) => (next) => {
  return {
    type: helpCenterTypes.FETCH_ARTICLES,
    endpoint: next,
    method: 'get',
    key,
    resetWithoutEmpty,
    schema: paginatorListSchema
  };
};

export const fetchArticles = ({
  goalUid,
  categoryID,
  portal = 'plus',
  nextPage = false,
  resetWithoutEmpty = false
}) => {
  const resultKey = `${goalUid}-${categoryID}-${portal}`;
  return paginateAction(
    `${freshbotCdnUrl}freshdesk/v1/categories/${categoryID}/articles?goal=${goalUid}&portal=${portal}`,
    getArticles(resultKey, resetWithoutEmpty),
    'articleFeed',
    resultKey,
    resetWithoutEmpty
  )(nextPage);
};

const getTickets =
  (key, jwtToken, { role }, resetWithoutEmpty) =>
  (next) => {
    let url = next;
    try {
      const absUrl = new URL(next);
      absUrl.searchParams.append('role', role);
      url = absUrl.href;
    } catch (err) {
      url = next;
    }
    return {
      type: helpCenterTypes.FETCH_TICKETS_HISTORY,
      endpoint: url,
      method: 'get',
      key,
      resetWithoutEmpty,
      schema: paginatorListSchema,
      headers: {
        authorization: `Bearer ${jwtToken}`
      }
    };
  };

export const fetchTickets = ({
  portal = 'plus',
  nextPage = false,
  resetWithoutEmpty = false,
  jwtToken = '',
  role = 'learner'
}) => {
  const resultKey = `${portal}-history`;
  return paginateAction(
    `${freshbotUrl}history/tickets?per_page=3`,
    getTickets(resultKey, jwtToken, { role }, resetWithoutEmpty),
    'tickets',
    resultKey,
    resetWithoutEmpty
  )(nextPage);
};

export const fetchArticleInfo =
  ({ articleID }) =>
  (dispatch) =>
    dispatch({
      type: helpCenterTypes.FETCH_ARTICLE_INFO,
      endpoint: `${freshbotCdnUrl}freshdesk/v1/articles/${articleID}`,
      method: 'get'
    });

export const sendFeedback =
  ({ articleID, positiveFeedback }) =>
  (dispatch) =>
    dispatch({
      type: helpCenterTypes.FETCH_ARTICLE_INFO,
      endpoint: `${freshbotUrl}freshdesk/v1/articles/${articleID}/feedback`,
      method: 'post',
      data: {
        positive_feedback: positiveFeedback
      }
    });
